var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 212,
    viewBox: "0 0 117 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117 171.999V211.999H53L50 200H43L40 189H33L30 179V101H14L12 94L11 90H4L0 79L8 76.9991V62.9991H37.0014V11.9991H62.0007L79 0L87 11.9991V51H109L117 62.9991V101.106H88.0992L88 171.999H102.5L109 160L117 171.999Z",
    fill: "#F86C14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109 160V200H50L48.9362 189.794C45.8539 189.553 43.0623 189.24 40 189C39.6397 185.875 39.3091 183.363 38.9488 180.218C36.2468 179.797 33.8428 179.581 30 179V90H11L8.8065 80.1525C6.22459 79.7518 3.3825 79.5209 0 79V51H29.0014V0H79V51H109V89.1073H80.0992L80 160H109Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT);
export default __webpack_public_path__ + "static/media/T.fff1b1fa36a1d94ead8004e968ab9fe3.svg";
export { ForwardRef as ReactComponent };